<ng-container>
  <div class="col file-container">
    <div class="row">
      @if (!isInvalid) {
        <div class="col-md-3">
          <a href="{{file.fileurl}}" target="_blank">{{file.filename}}</a>
        </div>
      }
      @if (isInvalid) {
        <div class="col-md-3" style="color: red">
          <div class="row">
            <div style="max-width: 85%; min-width: 85%" >{{file.filename}}</div>
            <i class="material-icons" style="max-width: 15%; min-width: 15%; font-size: 14px">warning</i>
          </div>
        </div>
      }
      <div class="col-md-3">
        <span><input type="checkbox" name="include_in_package" [formControl]="includePackageControl" [disabled]="readOnly">Include</span>
      </div>
      <div class="col-md-6">
        <div class="row" style="justify-content: space-between">
          <div class="col-md-11 file-url" matTooltip="Copy URL text" [cdkCopyToClipboard]="file.fileurl ?? ''">
            {{file.fileurl}}
          </div>
          <div style="max-width: 30px;">
            <div class="delete-file-button" (click)="deleteFile()">
              <i class="material-icons" style="font-size: 16px">close</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
